var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget',{attrs:{"color":_vm.color,"icon":"fa fa-robot","title":"Success calls","percent":_vm.percent,"value":_vm.value,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }